module.exports = __webpack_public_path__ + "media/images/front/treatment_support/setting_add_home_screen/safari-143d9a9c81a9848689993ba2792927c3.png";